module.exports = __webpack_public_path__ + "img/card-generic-alt.439036c3.svg";